var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-10"},[_c('v-img',{staticClass:"shrink",attrs:{"alt":"mulher tech","src":require("../assets/img/header.svg"),"width":"120vw"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }